export class CompanyAddressInfo {
  CompanyAddressID: number
  CompanyID: number
  CompanyName: string
  CompanyAddress: string
  CompanyPostCode: string
  CompanySubDistrictCode: string
  CompanySubDistrictName: string
  CompanyDistrictCode: string
  CompanyDistrictName: string
  CompanyProvinceCode: string
  CompanyProvinceName: string
  CompanyFlagDefault: string
  CompanyAddressCountryCode: string
  CompanyAddressCreateDate: string
  CompanyAddressCreateBy: string
  CompanyAddressUpdateDate: string
  CompanyAddressUpdateBy: string
  CompanyAddressFlagDelete: string
  rowOFFSet: number
  rowFetch: number
  itemTotal: number
}
